<template>
  <div>
    <LDBsTable
      url="cause-of-maintance"
      defaultSort="name"
      defaultOrder="asc"
      :query="query"
      :columns="columns"
      :clear="clear"
      :defaultOptions="options"
    >
      <div class="form-group col-lg-6">
        <label for="cause_of_maintance">{{ $t("cause_of_maintance") }}</label>
        <input
          type="text"
          id="cause_of_maintance"
          name="cause_of_maintance"
          class="form-control"
          :placeholder="$t('ph_cause_of_maintance')"
          v-model="query.name"
        />
      </div>

      <div class="form-group col-lg-6">
        <label for="isActive">{{ $t("active") }}</label>
        <vue-select
          class="bg-white"
          name="isActive"
          :placeholder="$t('select_a_item')"
          label="label"
          :options="[
            { label: 'SIM', value: true },
            { label: 'NÃO', value: false },
          ]"
          v-model="query.isActive"
          :reduce="(query) => query.value"
          :select-on-tab="true"
        />
      </div>
    </LDBsTable>
  </div>
</template>

<script>
import LDBsTable from "@/components/shared/LDBsTable";

export default {
  name: "CauseOfMaintanceList",
  components: {
    LDBsTable,
  },
  data() {
    return {
      columns: [
        {
          title: this.$t("name"),
          field: "name",
          sortable: true,
        },
        {
          title: this.$t("active"),
          field: "isActive",
          formatter: function (value) {
            return value ? "SIM" : "NÃO";
          },
          sortable: true,
        },
        {
          key: "id",
          field: "id",
          align: "center",
          width: "100%",
          formatter: function (value) {
            return `<a href="#/main/causeofmaintance/${value}" class="edit btn btn-action btn-primary btn-circle light-bottom-shadow text-white"><i class="fas fa-pen"></i></a>`;
          },
        },
      ],
      options: {
        exportOptions: { fileName: "causas_de_manutencao" },
      },
      query: {
        id: "",
        name: "",
        isActive: "",
      },
    };
  },
  methods: {
    clear() {
      (this.query.name = ""), (this.query.isActive = "");
    },
  },
};
</script>
